export default "__VITE_ASSET__$diTLdwn__"